export class PushNotificationService {
    public async addSubscription(): Promise<void> {
        if ('PushManager' in self) {
            let serviceWorkerRegistration = await navigator.serviceWorker.ready;
            let pushSubscription = await serviceWorkerRegistration.pushManager.getSubscription();
            if (!pushSubscription) {
                let result = await Notification.requestPermission();
                if (result === "granted") {
                    let publicKey = await this.getPublicKey();
                    if (publicKey) {
                        let pushSubscription = await serviceWorkerRegistration.pushManager.subscribe({
                            userVisibleOnly: true,
                            applicationServerKey: publicKey
                        });
                        await fetch('b-notification/api/views/push', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                "Authorization": `Bearer ${(window as any).courierPortal?.profile.token}`
                            },
                            body: JSON.stringify({ pushSubscription: pushSubscription })
                        }).catch(_ =>
                            console.error('Failed to store the Push Notifications subscription on server')
                        );
                    }
                }
            }
        }
    }

    private async getPublicKey(): Promise<string | undefined> {
        var response = await fetch('b-notification/api/views/publicKey', {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${(window as any).courierPortal?.profile.token}`
            },
        })
        if (response.ok) {
            return response.text();
        }
        else {
            console.error('Error during getting public key');
            return undefined;
        }
    }
}